"use client";

import { createContext, useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { fetchCartItems, addCartItem, removeCartItem } from "../api/services/cart";
import "react-toastify/dist/ReactToastify.css";

const CartContext = createContext(null);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItemsState, setCartItemsState] = useState({ items: [] });

  const fetchCart = async () => {
    try {
      const data = await fetchCartItems();
      setCartItemsState(data);
    } catch (error) {
      null;
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const addCartItemHandler = async (productId) => {
    try {
      const data = await addCartItem({ productId });
      setCartItemsState(data);
      toast.success("محصول به سبد خرید اضافه شد");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        toast.error("لطفا ابتدا وارد حساب خود شوید");
      } else {
        toast.error(error.response.data.message || error.response.data);
      }
    }
  };

  const removeCartItemHandler = async (productId, currentCount) => {
    try {
      const data = await removeCartItem({
        productId,
        currentCount: Math.max(0, currentCount),
      });
      if (currentCount <= 1) {
        toast.success("محصول از سبد خرید حذف شد");
      } else {
        toast.success("محصول از سبد خرید کم شد");
      }
      setCartItemsState(data);
    } catch (error) {
      if (error.response && error.response.data.message) {
        toast.error(error.response.data.message);
      }
    }
  };

  const contextValue = {
    cartItems: cartItemsState,
    setCartItemsState,
    addCard: addCartItemHandler,
    removeCard: removeCartItemHandler,
    refetchCart: fetchCart,
  };

  return <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>;
};
